import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNumber1Solid = function SvgNumber1Solid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 10 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M7.493 19.234c1.078 0 1.963-.913 1.963-1.963V2.672A2.277 2.277 0 0 0 7.188.405c-.636 0-1.216.25-1.63.664l-4.37 4.368c-.276.304-.47.691-.47 1.161 0 .885.72 1.632 1.632 1.632.442 0 .857-.194 1.161-.498l1.99-2.074v11.613c0 1.05.886 1.963 1.992 1.963",
        clipRule: "evenodd"
    })));
};

export { SvgNumber1Solid as ReactComponent };
//# sourceMappingURL=Number1Solid.svg.es.js.map
